import { useInvoiceSettingCertificate } from '@/core/domain/invoice/certificate/Certificate.hooks';
import { Alert, Button, Checkbox, Col, Row } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { LinkOutlined } from '@ant-design/icons';
import { Group } from '@/components/_common';

const ExpiredCertificateAlert = ({ companyId }: { companyId: number }) => {
  const { data, mutateAsync } = useInvoiceSettingCertificate();
  const [isAfter, setIsAfter] = useState(false);
  const [dateDifference, setDateDifference] = useState<number>(0);

  useEffect(() => {
    setIsAfter(false);
    mutateAsync(companyId);
  }, [companyId]);

  useEffect(() => {
    if (companyId) {
      const currentDate = moment(new Date());
      const lastNotification = localStorage.getItem(
        `do_not_display_alert_five_days_${companyId}`,
      );
      const oneMonthBeforeDate = currentDate.clone().add(1, 'months');

      setDateDifference(moment(data?.expirationDate).diff(currentDate, 'days'));

      if (
        data?.expirationDate &&
        moment(data?.expirationDate).isBefore(oneMonthBeforeDate, 'day') &&
        !moment(lastNotification).isAfter(currentDate)
      ) {
        setIsAfter(true);
      }
    }
  }, [data]);

  function doNotDisplayAlert() {
    setTimeout(() => {
      const newDate = moment(new Date());
      localStorage.setItem(
        `do_not_display_alert_five_days_${companyId}`,
        newDate.add(5, 'days').toISOString(),
      );

      setIsAfter(false);
    }, 1000);
  }

  return isAfter ? (
    <Alert
      closable
      type="warning"
      message={
        <Group>
          <b>
            {dateDifference > 0
              ? `O certificado utilizado na empresa selecionada está prestes a vencer; restam apenas ${dateDifference} dias.`
              : `O certificado utilizado na empresa selecionada já expirou; há ${Math.abs(
                  dateDifference,
                )} dias.`}
          </b>
        </Group>
      }
      description={
        <Row>
          <Col span={24}>
            <Button
              icon={<LinkOutlined style={{ marginRight: -12 }} />}
              onClick={() => window.open(`/app/settings/fiscal`)}
              type="link"
            >
              {`Data de expiração: ${moment(data?.expirationDate).format(
                'DD/MM/YYYY',
              )}`}
            </Button>
          </Col>

          <Col span={24}>
            <Checkbox onClick={doNotDisplayAlert}>
              Não exibir esse alerta nos próximos 5 dias.
            </Checkbox>
          </Col>
        </Row>
      }
      style={{ marginBottom: 24 }}
    />
  ) : (
    <></>
  );
};

export default ExpiredCertificateAlert;
